import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./global.css";
import { BrowserRouter } from "react-router-dom";
import {
  AggregatorProvider,
  WalletProvider,
} from "./pages/MainV3/hooks/content";
import { ThirdwebProvider } from "thirdweb/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { store } from "./controller/state";
import { Provider } from "react-redux";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <WalletProvider>
          <AggregatorProvider>
            <ThirdwebProvider>
              <QueryClientProvider client={queryClient}>
                <App />
              </QueryClientProvider>
            </ThirdwebProvider>
          </AggregatorProvider>
        </WalletProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
